/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceivedAt
 */
export interface ReceivedAt {
}

/**
 * Check if a given object implements the ReceivedAt interface.
 */
export function instanceOfReceivedAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReceivedAtFromJSON(json: any): ReceivedAt {
    return ReceivedAtFromJSONTyped(json, false);
}

export function ReceivedAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceivedAt {
    return json;
}

export function ReceivedAtToJSON(value?: ReceivedAt | null): any {
    return value;
}

